export var ScheduleType;
(function (ScheduleType) {
    ScheduleType["SCHEDULE_TYPE_UNSPECIFIED"] = "UNSPECIFIED";
    ScheduleType["SCHEDULE_TYPE_STANDARD"] = "STANDARD";
    ScheduleType["SCHEDULE_TYPE_PITR"] = "PITR";
})(ScheduleType || (ScheduleType = {}));
